<template>
    <div>
        <div class="flex justify-end flex gap-3">
            <vs-button class="float-right" color="primary" icon-pack="feather" icon="icon-settings"
                @click="isChangePriority = true" v-if="!isChangePriority">
                {{ $t('settings.addSetting') }}
            </vs-button>
            <vs-button @click="saveStatusData" icon-pack="feather" icon="icon-check" v-if="isChangePriority">
                {{ $t('button.save') }}
            </vs-button>
            <vs-button class="" color="danger" type="border" icon-pack="feather" icon="icon-x" @click="cancelSetting"
                       v-if="isChangePriority">
                {{ $t('settings.close') }}
            </vs-button>
        </div>
        <div>
            <draggable @end="endMove" :list="dataView" :disabled="!isChangePriority">
                <div v-for="(item, index) in dataView" :key="index" class="vx-card px-6 py-2 mt-4 ">
                    <div class="vx-row mt-2">
                        <div  :class="isChangePriority ? 'vx-col w-1/3' : 'vx-col w-1/2'">
                            <vs-input v-model="item.title" class="w-full set-input" :readonly="!isChangePriority" />
                        </div>
                        <div :class="isChangePriority ? 'vx-col w-1/3' : 'vx-col w-1/2'">
                            <input type="color" v-model="item.color" class="w-full" :disabled="!isChangePriority"
                                   style="height: 37.6px">
                        </div>
                        <div :class="isChangePriority ? 'vx-col w-1/3 flex item-center' : 'hidden'">
                            <vx-tooltip :text="$t('button.delete')" class="flex items-center">
                                <feather-icon svg-classes="h-6 w-6" icon="XSquareIcon" class="text-danger"
                                              @click=" removeItem(index)"></feather-icon>
                            </vx-tooltip>
                        </div>
                    </div>
                </div>
            </draggable>
            <div class="mt-8" v-if="isChangePriority">
                <vs-button icon-pack="feather" icon="icon-plus" @click="addItem">{{ $t('settings.add') }}</vs-button>
            </div>
        </div>
    </div>

</template>

<script>
import draggable from 'vuedraggable';
import vSelect from 'vue-select'

export default {
    components: {
        draggable,
        vSelect
    },
    data() {
        return {
            isChangePriority: false,
            prioritysOptions: [],
            dataView: [],
            settingsDataNew: {
                color: null,
                priority: null,
                title: null,
            },
            body: {},
        }
    },
    created() {
        this.getPriority();
    },
    methods: {
        endMove() {
            if (this.dataView && this.dataView.length > 0) {
                this.dataView.forEach((el, index) => {
                    return el.priority = index;
                });
            }
        },
        cancelSetting() {
            this.isChangePriority = false
            this.getPriority();
        },
        addItem() {
            this.dataView.push({ color: '#000000', priority: this.dataView.length, title: '', });
        },
        removeItem(index) {
            this.dataView.splice(index, 1);
            if (this.dataView && this.dataView.length > 0) {
                this.dataView.forEach((el, index) => {
                    return el.priority = index;
                });
            }
        },
        getPriority() {
            return new Promise((resolve, reject) => {
                this.$vs.loading()
                this.$crm.get(`/setting/organization-task-priority/find-by-organization-id`).then((response) => {
                    this.$vs.loading.close()
                    if (response.data && response.data.length > 0) {
                        this.dataView = response.data
                        this.prioritysOptions = response.data.map(el => {
                            return {
                                value: el.priority,
                                label: el.priority
                            }
                        })
                    }
                    resolve(response)
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Lỗi',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',

                    });
                })
            })
        },
        saveStatusData() {
            let item = this.dataView.find(el => el.title.trim().length === 0)
            if (item) {
                return this.$vs.notify({
                    text: 'Không được để trống tiêu đề cấp độ!',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            }
            this.$vs.loading()
            this.$crm.post(`/setting/organization-task-priority/save`, this.dataView).then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    color: 'success',
                    text: `Tạo mới thành công`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
                this.isChangePriority = false
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            })
        }
    },
};
</script>

<style></style>
